(function ($, Drupal, once) {
  'use strict';
  Drupal.behaviors.dlaMembershipDirectoryLanding = {
    attach: function attach(context, settings) {

      var isMobile = false; //initiate as false
      // device detection
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))
        || $(window).width() <= 768
      ) {
        isMobile = true;
      }

      // Due to limitation in views where selecting parent term does not pull in content tagged with the child term,
      // we use a function that selects options in hidden category dropdown based on selected option in the custom created
      // parent category dropdown where the data-child-terms attribute is pre-populated (via _dla_mbe_parent_categories which is
      // defined in dla_mbe.module and used in dla_form_alter in alter.inc) with the child category tids based on the "category" taxonomy parent child structure
      // $('select[name="parent_regions"]').once().on('change', function() {
      //   var selected_child_terms = [];
      //   $('select[name="field_neighborhood_target_id[]"]').val('All');
      //   if ($(this).children("option:selected").attr("data-child-terms") != undefined) {
      //     selected_child_terms = $(this).children("option:selected").attr("data-child-terms").split(',');
      //     $('select[name="field_neighborhood_target_id[]"]').val(selected_child_terms);
      //   }
      // });

      // Set up some display conditions for elements in top nav
      // The function of the top nav elements differs based on mobile or desktop
      if (isMobile) {
        // Hide filters initially
        $(".view-membership-directory .view__header").hide();
        //Ensure labels for select dropdown can be seen by removing class "visually-hidden"
        $('.view-mmembership_directory .view__header .js-form-type-select label').removeClass('visually-hidden');
        $('.view-membership-directory .view__header .form-item--type-textfield label').addClass('visually-hidden');

        // Ensure search icon is displayed for mobile
        // It is set to be hidden for welcome back pages but we will repurpose this icon to activate and hide filter
        // $('.search_icon').css({"display": "flex", "justify-content": "end"});
        //$('.search_icon').css('visibility', 'visible');
        $('.search_icon').css({"visibility": "visible", "display": "flex"});
        // Repurpose search icon to activate and hide filter
        $('#la_search', context).on('click', function() {
          $(".view-membership-directory .view__header").addClass("sticky").show();
          $('.dla-navbar_container').removeClass('search_open');
          $(this).hide();
          $('.dla-region-header, .dla-tabs__nav_button, .dla-region-tabs, .paragraph--type--carousel, .paragraph--type--feature, .paragraph--type--text, .block-dla-membership-directory, .newsletter-signup, .site-footer').hide();
          $('#la_close_search').show();
        });

        $('#la_close_search', context).on('click', function() {
          $(".view-membership-directory .view__header").removeClass("sticky").hide();
          $('.dla-navbar_container').removeClass('search_open');
          $(this).hide();
          $('#la_search').show();
          $('.dla-region-header, .dla-tabs__nav_button, .dla-region-tabs, .paragraph--type--carousel, .paragraph--type--feature, .paragraph--type--text, .block-dla-membership-directory, .newsletter-signup, .site-footer').show();
        });

      } else {
        // If we are on a Desktop device then we will always hide search icon and forms
        $('.search_icon').css("display", "none");
        $('.search_form').css("visibility", "hidden");

        //Ensure labels for select dropdown is hidden but still visible to screen readers by adding the class "visually-hidden"
        $('.view-membership-directory .view__header label:not(#label-edit-field-open)').addClass('visually-hidden');

      }

      // Move the "all" option from the following dropdowns since we are using multiple select with chosen wrapper
      $('select[name="field_membership_directory_target_id[]"] option[value=All]').remove();
      $('select[name="field_neighborhood_target_id[]"] option[value=All]').remove();
      $('select[name="field_region_target_id[]"] option[value=All]').remove();

      // Ensure that dropdown are converted to chosen
      $('select[name="field_membership_directory_target_id[]"]').chosen().addClass('form-select');
      $('select[name="field_neighborhood_target_id[]"]').chosen().addClass('form-select');
      $('select[name="field_region_target_id[]"]').chosen().addClass('form-select');

      // Apply special formatting for chosen dropdown to limit height of selected elements for desktop users
      if (isMobile == false) {
        $('.view__filters__wrapper .form-item--type-select').mouseover(function() {
          $(this).css('overflow', 'visible');
        });
        $('.view__filters__wrapper .form-item--type-select').mouseout(function() {
          $(this).css('overflow', 'hidden');
        });
      }

      // $(document).once().ready(function (event) {
      $(once('dla-processed', 'html')).ready(function(event) {

        var offsetFilter = $(".view-membership-directory .view__header").offset();
        // height of current scroll that will make the filter sticky
        var stickyHeight = offsetFilter.top - $("#dla-navbar").height();

        // Resets values in filter when Clear button is clicked
        $('input[id^=edit-reset]').on('click', function(e) {

          // clear select sessionStorage keys
          for (var keySession in sessionStorage) {
            if (keySession.indexOf('edit-field') !== -1) {
              sessionStorage.removeItem(keySession);
            }
          }

          e.preventDefault();
          $('.views-exposed-form .form-item--type-textfield input.form-text').val('');
          $('.views-exposed-form .form-select:not([multiple="multiple"])').val('All');

          // Deselect for Chosen dropdowns
          // $('.views-exposed-form .form-select[multiple="multiple"] option:selected').removeAttr('selected');
          $('.views-exposed-form .form-select[multiple="multiple"]').find('option').prop('selected', '');
          $('.views-exposed-form .form-select[multiple="multiple"]').trigger('chosen:updated');

          // Deselect checkboxes
          $('.views-exposed-form [type="checkbox"]'). prop("checked", false);

          // Submit form again once values are cleared to bring back default results
          $( ".views-exposed-form input[id^=edit-submit-membership-directory]" ).trigger( "click" );
        });

        // Set up function to return true when item is in view, applies to table of listings
        $.fn.isInViewport = function () {
          var elementTop = $(this).offset().top;
          var elementBottom = elementTop + $(this).outerHeight();
          var viewportTop = $(window).scrollTop();
          var viewportBottom = viewportTop + $(window).height();
          return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        var previousScroll = 0;
        $(window).on('scroll', function () {
          var currentScroll = $(this).scrollTop();

          if (currentScroll > previousScroll){
            // Direction Down
            // Make filter sticky once scrolled past required height
            // - for desktop only
            // - We not add class sticky after user just submitted filter to allow filter to be positioned correctly above results
            if (stickyHeight < currentScroll && isMobile == false) {
              // The class enteredSearch is a flag to detect whether or not user entered filter
              // We must only add the sticky class if this class enteredSearch is not present
              if (!$(".view-membership-directory .view__header").hasClass("enteredSearch")) {
                $(".view-membership-directory .view__header").addClass("sticky");
                // Insert table header as last element in filter
                var height_sticky_header = $(".view-membership-directory .view__header").height() + $(".dla-navbar").height();
                $("table.sticky-header").css("top", height_sticky_header + "px");
                $("table.sticky-header").css("visibility", "visible");
              } else {
                // This means that the class enteredSearch was present and user was taken to top
                // And we did not add sticky class to allow for filter to be positioned correctly
                // But we must now remove the class enteredSearch to resume normal sticky function
                $(".view-membership-directory .view__header").removeClass("enteredSearch");
              }
            }

          } else {
            // Direction Up
          }

          // When on desktop, remove sticky from filter when scrolling all the way to the top so that it does not overlay rotator
          // Calculate the combined height of all paragraph divs before the view starts
          var numItems = $('.node__content').first().children('.paragraph').length;
          var totalHeight = $('.dla-region-tabs').height() + $('.dla-navbar').height();
          $('.node__content').first().children('.paragraph').each(function (index) {
            if (index < numItems - 1) {
              totalHeight = totalHeight + $(this).height();
            }
          });
          if ($(this).scrollTop() <= totalHeight && isMobile == false) {
            $(".view-membership-directory .view__header").removeClass("sticky");
          }

          // hide certain sticky headers for mobile
          if (isMobile == true) {
            $("table.sticky-header th.views-field").css("display", "none");
          }

          previousScroll = currentScroll;

          // Detect when table of listing is in view to make certain adjustments (show or hide feedbackify, table layout for mobile size)
          if ($('.view-id-membership_directory .views-table').isInViewport()) {
            if (isMobile == false) {
              $("table.sticky-header").show();
            }
            if (isMobile) {
              $("table.sticky-header").css("top", $("#dla-navbar").height() + "px");
              $("table.sticky-header th.views-field").css("display", "none");
            } else {
              $("table.sticky-header th.views-field").css("display", "table-cell");
            }
          } else {
            if (isMobile == false) {
              $("table.sticky-header").hide();
            }
          }
        });

      });

      /* Views Ajax Content Load Autoscroll Feature Disabled */
      Drupal.AjaxCommands.prototype.viewsScrollTop = null;

      // Add some custom functions that fire whenever a user has submitted the filter form
      $(document).ajaxComplete(function(event, xhr, settings) {

        let params = new URLSearchParams(settings.extraData);
        let viewname = params.get("view_name");

        // Run the following only if the ajax submit came from the views exposed filter
        // since we have other forms (newsletter) on the page that also use the ajax event
        if (viewname == 'membership_directory') {

          // Calculate the combined height of all paragraph divs before the view starts
          var numItems = $('.node__content').first().children('.paragraph').length;
          var totalHeight = $('.dla-region-tabs').height() + $('.dla-navbar').height();
          $('.node__content').first().children('.paragraph').each(function (index) {
            if (index < numItems - 1) {
              totalHeight = totalHeight + $(this).height();
            }
          });

          $('.dla-navbar_container').removeClass('search_open');
          if (settings.extraData) {
            $('html, body').animate({scrollTop: totalHeight}, 100);
          }
          $(".view-membership-directory .view__header").removeClass("sticky");
          $(".view-membership-directory .view__header").addClass("enteredSearch");

          // Hide close search icon
          $('.dla-navbar_container').removeClass('search_open');
          $('#la_close_search').hide();
          $('#la_search').show();

          // Due to the recent addition of the chosen dropdowns for multi-select function, it sometimes hides the table headers after each selection
          // To address this, we nudge the window to scroll a little to activate window scroll event to get the table headers repositioned
          window.scrollBy(0, 2);

          if (isMobile) {
            // Ensure these elements shows after every search
            $('.dla-region-header, .dla-tabs__nav_button, .dla-region-tabs, .paragraph--type--carousel, .paragraph--type--feature, .paragraph--type--text, .block-dla-membership-directory, .newsletter-signup, .site-footer').show();
          }

        }

      });

    }
  };
})(jQuery, Drupal, once);
